var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-section"},[_c('div',[_c('q-icon',{attrs:{"name":_vm.icon,"size":"36pt"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }